import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-67a80bcf"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SystemCsvTranslationImport = _resolveComponent("SystemCsvTranslationImport")!
  const _component_SystemCsvTranslationExport = _resolveComponent("SystemCsvTranslationExport")!
  const _component_TabPanel = _resolveComponent("TabPanel")!
  const _component_TabView = _resolveComponent("TabView")!
  const _component_EntryDialog = _resolveComponent("EntryDialog")!
  const _component_Message = _resolveComponent("Message")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_TabView, {
      activeIndex: _ctx.activeTabOption,
      "onUpdate:activeIndex": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.activeTabOption) = $event))
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabOptions, (tab) => {
          return (_openBlock(), _createBlock(_component_TabPanel, {
            key: tab.value
          }, {
            header: _withCtx(() => [
              _createElementVNode("i", {
                class: _normalizeClass(tab.icon)
              }, null, 2),
              _createTextVNode(" " + _toDisplayString(tab.value), 1)
            ]),
            default: _withCtx(() => [
              (tab.value === _ctx.$t('Squeeze.General.Import'))
                ? (_openBlock(), _createBlock(_component_SystemCsvTranslationImport, {
                    key: 0,
                    showErrorMessage: _ctx.showErrorMessage,
                    selectedFiles: _ctx.files,
                    fileTypes: _ctx.fileTypes,
                    onUpdate: _ctx.onUpdate,
                    onFileUploader: _ctx.fileUploader
                  }, null, 8, ["showErrorMessage", "selectedFiles", "fileTypes", "onUpdate", "onFileUploader"]))
                : _createCommentVNode("", true),
              (tab.value === _ctx.$t('Squeeze.General.Export'))
                ? (_openBlock(), _createBlock(_component_SystemCsvTranslationExport, {
                    key: 1,
                    fileTypes: _ctx.fileTypes,
                    onStartTranslationFileDownload: _ctx.startTranslationFileDownload
                  }, null, 8, ["fileTypes", "onStartTranslationFileDownload"]))
                : _createCommentVNode("", true)
            ]),
            _: 2
          }, 1024))
        }), 128))
      ]),
      _: 1
    }, 8, ["activeIndex"]),
    _createVNode(_component_EntryDialog, {
      show: _ctx.showWarningDialog,
      onOnClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showWarningDialog = false)),
      onOnConfirm: _ctx.startFileUpload,
      headerText: _ctx.$t('Squeeze.System.CreateResetTranslations'),
      saveButtonText: _ctx.$t('Squeeze.General.Execute')
    }, {
      content: _withCtx(() => [
        _createElementVNode("b", null, _toDisplayString(_ctx.$t('Squeeze.General.Attention')), 1),
        _createTextVNode(": " + _toDisplayString(_ctx.$t('Squeeze.System.CreateResetTranslationsConfirm')), 1)
      ]),
      _: 1
    }, 8, ["show", "onOnConfirm", "headerText", "saveButtonText"]),
    _createVNode(_component_Dialog, {
      header: _ctx.$t('Squeeze.General.Info'),
      visible: _ctx.showImportErrors,
      "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.showImportErrors) = $event)),
      modal: true
    }, {
      default: _withCtx(() => [
        _createVNode(_component_Message, {
          closable: false,
          severity: "info"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('Squeeze.General.SuccessButWithErrors')), 1),
            _hoisted_1,
            _createTextVNode(" " + _toDisplayString(_ctx.$t('Squeeze.General.CountOfErrors', {errorNumber: _ctx.errorCount})), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_Message, {
          closable: false,
          severity: "error"
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.importErrors, (error) => {
              return (_openBlock(), _createElementBlock(_Fragment, { key: error }, [
                _createTextVNode(_toDisplayString(error), 1),
                _hoisted_2
              ], 64))
            }), 128))
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["header", "visible"])
  ], 64))
}